// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YV6y","largestCol":"styles_largestCol__32bgR","smallestCol":"styles_smallestCol__2YZSe"};